<script>
export default {
    name: 'AvatarText',

    data() {
        return {}
    },
    methods: {
        avatarProfileText(userObject) {
            if (userObject.display_name) {
                return userObject.display_name[0] + userObject.display_name[1];
            } else if (userObject.handle) {
                return userObject.handle[0] + userObject.handle[1];
            } else if (userObject.first_name && userObject.last_name) {
                return userObject.first_name[0] + userObject.last_name[0];
            } else {
                return userObject.kolkinid[0] + userObject.kolkinid[1];
            }
        }
    },
}
</script>
